module.exports = __webpack_public_path__ + "img/high_dynamic_range.c095a17b.jpg";